<template>

  <p v-if="error" class="error">{{ error }}</p>
  <div class="cell small-12">
    <h1>Foreign Tax</h1>
    <p>Does your company pay employees under any foreign tax agreements, for example Appendix 5?</p>

    <div class="cell small-6">
      <form class="fieldset" @submit.prevent>
            <label class="radio-label custom-check"><input type="radio" value=true v-model="formData.hasForeignTaxSchemes">Yes<span class="radiomark"></span></label>
            <label class="radio-label custom-check"><input type="radio" value=false v-model="formData.hasForeignTaxSchemes">No<span class="radiomark"></span></label>
      </form>
    </div>

  </div>


</template>


<script setup>

import { ref } from 'vue'

const error = ref(null)


const props = defineProps({
  formData: Object
})


const validateStep = () => {
  if (props.formData.hasForeignTaxSchemes === undefined || props.formData.hasForeignTaxSchemes === null || props.formData.hasForeignTaxSchemes === '') {
    error.value = 'Please select an option.';
    return false;
  }
  error.value = null;
  return true;
}


const executeStep = async () => {
  return true;
}


defineExpose({ validateStep, executeStep });

</script>